import { PaymentType } from '../enums/payment-type';

export interface IPaymentMethod {
  type: PaymentType;
}
